"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _WKTWriter = _interopRequireDefault(require("../io/WKTWriter"));

var _MCIndexNoder = _interopRequireDefault(require("./MCIndexNoder"));

var _TopologyException = _interopRequireDefault(require("../geom/TopologyException"));

var _RobustLineIntersector = _interopRequireDefault(require("../algorithm/RobustLineIntersector"));

var _InteriorIntersectionFinder = _interopRequireDefault(require("./InteriorIntersectionFinder"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var FastNodingValidator =
/*#__PURE__*/
function () {
  function FastNodingValidator() {
    _classCallCheck(this, FastNodingValidator);

    FastNodingValidator.constructor_.apply(this, arguments);
  }

  _createClass(FastNodingValidator, [{
    key: "execute",
    value: function execute() {
      if (this._segInt !== null) return null;
      this.checkInteriorIntersections();
    }
  }, {
    key: "getIntersections",
    value: function getIntersections() {
      return this._segInt.getIntersections();
    }
  }, {
    key: "isValid",
    value: function isValid() {
      this.execute();
      return this._isValid;
    }
  }, {
    key: "setFindAllIntersections",
    value: function setFindAllIntersections(findAllIntersections) {
      this._findAllIntersections = findAllIntersections;
    }
  }, {
    key: "checkInteriorIntersections",
    value: function checkInteriorIntersections() {
      this._isValid = true;
      this._segInt = new _InteriorIntersectionFinder.default(this._li);

      this._segInt.setFindAllIntersections(this._findAllIntersections);

      var noder = new _MCIndexNoder.default();
      noder.setSegmentIntersector(this._segInt);
      noder.computeNodes(this._segStrings);

      if (this._segInt.hasIntersection()) {
        this._isValid = false;
        return null;
      }
    }
  }, {
    key: "checkValid",
    value: function checkValid() {
      this.execute();
      if (!this._isValid) throw new _TopologyException.default(this.getErrorMessage(), this._segInt.getInteriorIntersection());
    }
  }, {
    key: "getErrorMessage",
    value: function getErrorMessage() {
      if (this._isValid) return "no intersections found";

      var intSegs = this._segInt.getIntersectionSegments();

      return "found non-noded intersection between " + _WKTWriter.default.toLineString(intSegs[0], intSegs[1]) + " and " + _WKTWriter.default.toLineString(intSegs[2], intSegs[3]);
    }
  }, {
    key: "getClass",
    value: function getClass() {
      return FastNodingValidator;
    }
  }, {
    key: "interfaces_",
    get: function get() {
      return [];
    }
  }], [{
    key: "computeIntersections",
    value: function computeIntersections(segStrings) {
      var nv = new FastNodingValidator(segStrings);
      nv.setFindAllIntersections(true);
      nv.isValid();
      return nv.getIntersections();
    }
  }]);

  return FastNodingValidator;
}();

exports.default = FastNodingValidator;

FastNodingValidator.constructor_ = function () {
  this._li = new _RobustLineIntersector.default();
  this._segStrings = null;
  this._findAllIntersections = false;
  this._segInt = null;
  this._isValid = true;
  var segStrings = arguments[0];
  this._segStrings = segStrings;
};